import _ from "lodash";

import React from "react";
import { withApollo } from "react-apollo";
import Grid from 'material-ui/Grid';
import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper'
import Card, { CardContent, CardActions } from 'material-ui/Card';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import Select from 'react-select';
import { getRandomColor, increaseBrightness } from "../utils";

import ServerStats from "./ServerStats";
import PinStats from "./PinStats";
import Loading from "../../etc/Loading";

// @material-ui/icons
import Domain from "@material-ui/icons/Domain";
import SettingsPhone from "@material-ui/icons/SettingsPhone";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import {getPinStatsQuery, gq_projects, getStatsSubscriptions} from "../graph";
import {client, subClient} from "client";


class StatsView extends React.Component {

    constructor(props) {
      super(props);  
      this.state = {
        projects: {},
        serverData: {},
        triggerPinSub: false
      };

      this.renderCount = 0;
      this.isLoadingProjects = true;
      this.serverStatsSub = null;
    }

    componentDidMount() {
      this.isLoadingProjects = true;

      client.query({
          query: gq_projects,
          fetchPolicy: "network-only"
      }).then((data) => {
        const dataProjs = data.data.allProjects.edges;
        let projs = [];

        projs.push({
          label: 'All',
          value: -1
        });

        for (let i in dataProjs) {
          projs.push({
            label: dataProjs[i].node.name,
            value: parseInt(dataProjs[i].node.pid)
          });
        }

        this.isLoadingProjects = false;
        this.setState({projects: projs});
      });

      this.props.getServerStats().then((data) => {
        const serverData = JSON.parse(data.data.serverStats.jsonObject);
        this.setState({
          serverData: serverData
        });
      });

      // this.startServerStatsSubscription();
    }

    componentWillUnmount() {
      subClient.unsubscribeAll();
    }

    onTabChange(event, active) {
      if (active === 0) { //server tab
        this.startServerStatsSubscription();
        this.setState({
          triggerPinSub: false
        });
      }
      else if (active === 1) { //pin tab
        if (this.serverStatsSub)
          this.serverStatsSub.unsubscribe();

        this.setState({
          triggerPinSub: true
        });
      }
    }

    startServerStatsSubscription() {
      this.serverStatsSub = client.subscribe({
          query: getStatsSubscriptions // Subscription gql
        }).subscribe(
          response => {
            console.log('received: startServerStatsSubscription');
            const serverData = JSON.parse(response.data.serverStatsSub.jsonObject);
            console.log(serverData);

            this.setState({
              serverData: serverData
            });
          },
          error => {
            console.log(error);
          }
      );
    }


    render() {
      this.renderCount = this.renderCount + 1;

      if (this.isLoadingProjects)
        return (<Loading />);
      // <NavPills
            //   tabs={[
            //     {
            //       tabButton: "Server Stats",
            //       tabIcon: Domain,
            //       tabContent: (
            //         <ServerStats data={this.state.serverData}/>
            //       )
            //     },
            //     {
            //       tabButton: "Pin Stats",
            //       tabIcon: SettingsPhone,
            //       tabContent: (
            //         <PinStats 
            //           projects={this.state.projects}
            //           triggerPinSub={this.state.triggerPinSub}
            //         />
            //       )
            //     },
            //   ]}
            //   onTabChangeCallback={this.onTabChange.bind(this)} 
            // />
      return (
        <GridContainer justify="center">
          <ItemGrid xs={12} sm={12} md={12}>
            <PinStats 
              projects={this.state.projects}
              triggerPinSub={this.state.triggerPinSub}
            />
            
          </ItemGrid>
        </GridContainer>
      )
    }
}

export default (getPinStatsQuery)(StatsView);


// WEBPACK FOOTER //
// ./src/views/stats/components/StatsView.js